import React, { useEffect, useRef, useState } from 'react';

import { IntlProvider, useIntl } from 'react-intl-next';

import EmptyState from '@atlaskit/empty-state';
import InlineMessage from '@atlaskit/inline-message';

import SomethingWentWrong from '../../../assets/somethings-wrong.png';
import { messages } from '../../../common/utils/messages';
import { type FallbackProps } from '../../../common/utils/types';

import { FallbackWrapper, InitialTextWrapWrapper } from './styled';

const Fallback = ({ error, className }: FallbackProps & { className?: string }) => {
	const intl = useIntl();

	const ref = useRef<HTMLDivElement>(null);
	const [isSmallSize, setIsSmallSize] = useState<boolean | undefined>(undefined);

	const MIN_WIDTH_LIMIT = 258; // Width limit for the show small component
	const MIN_HEIGHT_LIMIT = 250; // Height limit for the show small component

	useEffect(() => {
		if (ref.current) {
			const { clientWidth, clientHeight } = ref.current;

			setIsSmallSize(
				clientWidth < MIN_WIDTH_LIMIT || (clientHeight < MIN_HEIGHT_LIMIT && clientHeight !== 0),
			);
		}
	}, []);

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<FallbackWrapper className={className} ref={ref}>
			{isSmallSize !== undefined &&
				(isSmallSize ? (
					<InlineMessage
						appearance="error"
						title={
							<InitialTextWrapWrapper>
								{intl.formatMessage(messages.errorMessage)}
							</InitialTextWrapWrapper>
						}
					>
						<span>{(error as Error).message}</span>
					</InlineMessage>
				) : (
					<EmptyState
						header={intl.formatMessage(messages.errorMessage)}
						description={(error as Error).message}
						imageHeight={MIN_HEIGHT_LIMIT}
						imageWidth={MIN_WIDTH_LIMIT}
						imageUrl={SomethingWentWrong}
					/>
				))}
		</FallbackWrapper>
	);
};

const DefaultFallbackComponent = (props: FallbackProps & { className?: string }) => {
	return (
		<IntlProvider locale="en">
			<Fallback {...props} />
		</IntlProvider>
	);
};

export default DefaultFallbackComponent;
